module.exports = {
	"Jovi": {
		"AWS": {
			"Cognito": {
				"IdentityPoolId": "us-east-1:15236ebb-30ed-47f4-9d26-e5dc9b15dfd3",
				"UserPoolId": "us-east-1_P29VQOamL",
				"ClientId": "mg1sh82h82sib5m1vu14echkv"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/DEV.json
// module id = 136
// module chunks = 0